<template>
  <footer id="footer">
    <p>{{getResource('FooterCompany')}} <a href="/Privacy Statement Ricoh MarCom Portal.pdf" target="_blank"> Privacy Statement</a> - <a href="static/cookie-policy/Index.html" target="_blank"> Cookie policy</a><p>
    <p>{{getResource('FooterSupport')}} <a href="mailto:marcom@ricoh-europe.com">marcom@ricoh-europe.com</a>.</p>
  </footer>
</template>

<script>
  import { getResource } from "../../vuex/helpers";
  export default {
    vuex: {
      actions: { getResource }
    }
};
</script>


<style lang="scss">
  @import '../../assets/scss/variables.scss';

  #footer{
    background: $green_light;
    padding: 43px 43px;
    height: 110px;
    overflow: hidden;
    box-sizing: border-box;

    p{
      max-width: 1100px;
      margin: 0px auto;
      font-size: 14px;
    }

    a{
      color: $green_dark;
      text-decoration: underline;
    }
  }
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?afbfb010